import lfRequest from '@/service/index'

export function getGeneratUrl(materialId: string) {
  return lfRequest.post<any[]>({
    url: `/main/promotionGenerate/generate/${materialId}`
  })
}
